// extracted by mini-css-extract-plugin
export var card = "_sa-0";